module.exports = __webpack_public_path__ + "static/img/zcgz.7a5b6881.png";